import _ from 'lodash';
import { Form, Select, Spin } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import React from 'react';

const { Option } = Select;

interface Props {
  form: WrappedFormUtils;
  payors: {
    id: string;
    name: string;
  }[];
  loading?: boolean;
  onChange: () => void;
}

export default class InsurancePayorField extends React.Component<Props, {}> {
  render(): JSX.Element {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form.Item label="Select the insurance carrier">
        {getFieldDecorator('carrier', {
          rules: [
            {
              required: true,
              message: 'Required',
            },
          ],
        })(
          <Select
            disabled={this.props.payors.length === 0}
            loading={this.props.loading}
            notFoundContent={this.props.loading ? <Spin size="small" /> : undefined}
            showSearch
            dropdownMatchSelectWidth={false}
            placeholder="Insurance Carrier"
            optionFilterProp="children"
          >
            {_.sortBy(this.props.payors, ['name']).map(payor => (
              <Option value={payor.id} key={payor.id}>
                {payor.name}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
    );
  }
}
